export default __webpack_public_path__ + "img/plus-one-icon-graphic-7a0b0daa11c8fa80b525207fba649046.png";